// extracted by mini-css-extract-plugin
export default {"detail_wrap":"DetailSingle_detail_wrap__zD3UK","detail_title":"DetailSingle_detail_title__ZPLb0","detail_value":"DetailSingle_detail_value__Z9T5P"};